import { render, staticRenderFns } from "./AlexChat.vue?vue&type=template&id=55ad6c76&scoped=true&"
import script from "./AlexChat.vue?vue&type=script&lang=js&"
export * from "./AlexChat.vue?vue&type=script&lang=js&"
import style0 from "./AlexChat.vue?vue&type=style&index=0&id=55ad6c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ad6c76",
  null
  
)

export default component.exports